<div class="box">
  <div class="header">
    <div
      *ngFor="let step of garr(instructions); let index = index"
      (click)="nextPage(index)"
      id="step{{ index }}"
      [ngStyle]="{ width: 'calc(' + 100 / instructions + '% - 17px' + ')' }"
      class="step"
    ></div>
    <div
      id="hover"
      [ngStyle]="{ width: 'calc(' + 100 / instructions + '% - 17px' + ')' }"
      class="active step"
    ></div>
  </div>
  <div class="body" *ngIf="recipe && recipe.instructions">
    <div
      (swipeleft)="swipe($event.type)"
      (swiperight)="swipe($event.type)"
      class="page"
      [ngStyle]="{ right: activePage == index ? 0 : distance[index] }"
      *ngFor="let step of recipe.instructions; let index = index"
    >
      <p class="step-title">مرحله {{ changePage(index) }}</p>
      <app-cooking-story-player
        *ngIf="(recipe.video && step?.end && step?.start) || step?.start == 0"
        [show]="recipe.video && activePage == index && step.end"
        [data]="{
          src: recipe.video,
          start: step.start,
          end: step.end,
          holder: recipe.image
        }"
      ></app-cooking-story-player>
      <p class="description">
        {{ step.text }}
      </p>
    </div>
    <div
      class="page"
      [ngStyle]="{ right: activePage == instructions ? 0 : '200%' }"
    >
      <p class="step-title">نوش جان.</p>
      <div class="final">
        <p class="food-name">
          {{ recipe.food.name }}
        </p>
        <div class="tool" (click)="Bookmarking()">
          <p>افزودن به علاقه‌مندی</p>
          <img src="assets/cookingbook/like.svg" *ngIf="!liked" alt="" />
          <img src="assets/cookingbook/liked.svg" *ngIf="liked" alt="" />
        </div>
        <div class="tool" (click)="showReportbottomSheet()">
          <p>ثبت بازخورد</p>
          <img src="assets/cookingbook/report.svg" alt="" />
        </div>
        <div class="tool" (click)="share()">
          <p>اشتراک‌گذاری</p>
          <img src="assets/cookingbook/share.svg" alt="" />
        </div>
      </div>
    </div>
    <div
      class="recipe-detail active"
      [ngStyle]="{
        'justify-content': activePage == instructions ? 'flex-end' : ''
      }"
    >
      <div
        class="recipe-detail-button"
        *ngIf="activePage != instructions"
        (click)="nextPage()"
      >
        <img src="assets/cookingbook/forward.svg" alt="" />
        <p>مرحله بعد</p>
      </div>
      <div class="recipe-detail-button exit" (click)="openRecipe()">
        <img src="assets/cookingbook/exit_blue.svg" alt="" />
        <p>خروج از آشبزی</p>
      </div>
    </div>
  </div>
</div>
<app-bottomsheet *ngIf="showReport" [type]="'recipe-report'"></app-bottomsheet>
